import React from "react";
import Box from "@material-ui/core/Box";
import InfoIcon from "@material-ui/icons/Info";
import { useTheme } from "@material-ui/core/styles";
import { type GridColumnHeaderParams } from "@material-ui/x-grid";

import type { Theme } from "src/theme";
import Tooltip from "src/components/Tooltip";

function RenderHeaderLabel({ params }: { params: GridColumnHeaderParams }) {
  const theme = useTheme() as Theme;
  const { custom: palette } = theme.palette.custom;
  const iconStyle = {
    fontSize: theme.typography.body2.fontSize,
    margin: "8px",
    color: palette.accent,
  };
  const tooltip = params.colDef.description;

  return (
    <Box
      className="MuiDataGrid-columnHeaderTitle"
      display="flex"
      alignItems="center"
    >
      {params.colDef.headerName}
      {tooltip ? (
        <Tooltip title={tooltip}>
          <InfoIcon style={iconStyle} />
        </Tooltip>
      ) : null}
    </Box>
  );
}

function renderHeaderLabel(params: GridColumnHeaderParams) {
  return <RenderHeaderLabel params={params} />;
}

export default renderHeaderLabel;
